var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fff"},[_c('div',{staticClass:"page_title"},[_vm._v(_vm._s(_vm.$t('privagypolicy.title')))]),_vm._v(" "),_c('div',{attrs:{"id":"TermsOfUse"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd1c3ec6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Privagypolicy.vue
// module id = null
// module chunks = 